/* eslint-disable no-prototype-builtins */
import axios from 'axios'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { standardSpinner } from '../../../../helpers/spinners'
import { positionChangeWidthSm, captionsArray } from '../../../../helpers/variableDefaults'
import { standardButton } from '../../../../helpers/buttons'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { standardErrorContainer } from '../../../../helpers/errors'
import { saveSuccessfulTypography, advisoryTypography } from '../../../../helpers/typographies'
import { selectElementWithIndex } from '../../../../helpers/selects'
import { descriptionTextField } from '../../../../helpers/textfields'
import { Input } from '../../../../helpers/globalHelpers'
import { titleAndAdvisoryJSX, saveAndCancelButtonsJSX } from '../../../../helpers/commonJSX'

export const captionsJSX = (
  mediaItem, setMediaItem,
  previousMediaItem, setPreviousMediaItem,
  loading, setLoading, 
  saveSuccessful, setSaveSuccessful,
  errors, setErrors,
  resetLoadingAndErrors, resetSaveSuccessful,
  width
) => {

  const showSaveAndCancelButtons = () => {
    // console.log('mediaItem.url ->', Object.keys(mediaItem).length > 0 ? mediaItem.url : 'No Url')
    // console.log('previousURL ->', previousURL)
    // console.log('mediaItem.url === previousURL ->', mediaItem.url === previousURL)
    return !(
      Object.keys(mediaItem).length > 0
      && 'captions' in mediaItem
      && (
        mediaItem.captions.length === previousMediaItem.captions.length
        && mediaItem.captions.filter((caption, index) => caption !== previousMediaItem.captions[index]).length === 0 
      )
      && 'subcaptions' in mediaItem
      && (
        mediaItem.subcaptions.length === previousMediaItem.subcaptions.length
        && mediaItem.subcaptions.filter((subcaptions, index) => subcaptions !== previousMediaItem.subcaptions[index]).length === 0 
      )
    )
  }

  const handleChangeCaption = (e, setErrors, setForm, form, index) => {
    // console.log('handleChangeCaption runs')
    e.preventDefault()

    setErrors({ ...errors, captions: false })
    setSaveSuccessful({ ...saveSuccessful, captions: false })

    const { name, value } = e.target

    if (name === 'subcaption' && value !== ' ') {
      
      const updatedSubcaptions = [ ...mediaItem.subcaptions ]
      updatedSubcaptions[index] = value
      setMediaItem({ ...mediaItem, subcaptions: [ ...updatedSubcaptions ] })
    
    } else if (name === 'caption') {

      const updatedCaptions = [ ...mediaItem.captions ]
      updatedCaptions[index] = value
      setMediaItem({ ...mediaItem, captions: [ ...updatedCaptions ] })
    
    }

  }

  const handleCancelPressed = () => {
    // console.log('handleCancelPressed runs')
    setMediaItem({ ...mediaItem, captions: previousMediaItem.captions, subcaptions: previousMediaItem.subcaptions })
    resetSaveSuccessful()
  }

  const handleSavePressed = async () => {
    // console.log('handleSavePressed runs')
    const objectToUpload = {
      captions: mediaItem.captions,
      subcaptions: mediaItem.subcaptions,
    }
    // console.log('objectToUpload ->', objectToUpload)

    // Upload Modifications
    if (
      !(
        (
          mediaItem.captions.length === previousMediaItem.captions.length
          && mediaItem.captions.filter((caption, index) => caption !== previousMediaItem.captions[index]).length === 0 
        )
        && (
          mediaItem.subcaptions.length === previousMediaItem.subcaptions.length
          && mediaItem.subcaptions.filter((subcaptions, index) => subcaptions !== previousMediaItem.subcaptions[index]).length === 0 
        )
      )
    ) {
      // console.log('attempting modify description')
      setLoading({ ...loading, captions: true })
      setErrors({ ...errors, captions: false })
      resetSaveSuccessful()
      
      try {
        // PUT request with updated profile object
        // await axios.put(`/api/users/${userId}`, newForm, {
        await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/media-items/${mediaItem._id}`, objectToUpload, {
          headers: {
            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
          },
        })

        setPreviousMediaItem({ ...previousMediaItem, captions: mediaItem.captions, subcaptions: mediaItem.subcaptions })

        setErrors({ ...errors, captions: false })
        setSaveSuccessful({ ...saveSuccessful, captions: true })
        setLoading({ ...loading, captions: false })
        
      } catch (error) {
        console.log(error)

        setErrors({ ...errors, captions: true })
        setLoading({ ...loading, captions: false })
      }
    } else {

      setErrors({ ...errors, captions: true })
      setLoading({ ...loading, captions: false })
    }
  }
  
  return (
    
    <Box
      sx={{
        py: 3, my: 2,
        width: '90%',
        maxWidth: '600px',
        backgroundColor: showSaveAndCancelButtons() ? 'lightgray' : 'whitesmoke',
        borderRadius: 3, boxShadow: 3,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '90%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        <Box sx={{ width: '100%' }}>
          <Input type="text" autoFocus="autoFocus" />
        </Box>

        {/* Title and Advisory JSX */}
        {titleAndAdvisoryJSX(
          'Captions/Subcaptions', 
          '*Add some context and personality',
          0
        )}


        {/* Captions */}
        {[0, 1, 2].map((captionIndex) => (
          <Box
            key={captionIndex}
            sx={{
              mt: captionIndex > 0 ? 2.5 : 0,
              width: '100%',
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
            }}
          >

            <Box
              sx={{
                width: '100%',
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
              }}
            >
              {/* Caption Select */}
              {selectElementWithIndex(
                'caption',
                `Caption ${captionIndex + 1}`,
                mediaItem.captions[captionIndex] === '' ? 'No Caption' : mediaItem.captions[captionIndex],
                captionIndex,
                loading.captions,
                true,
                captionsArray,
                handleChangeCaption,
                mediaItem,
                setMediaItem,
                setErrors,
                width,
                0,
                0,
                'white'
              )}

              {/* Subcaption */}
              {descriptionTextField(
                'subcaption',
                mediaItem.subcaptions[captionIndex],
                captionIndex,
                // `Subcaption ${captionIndex + 1}`,
                mediaItem.subcaptions[captionIndex].length === 0 ? `` : `Subcaption ${captionIndex + 1}`,
                2,
                75,
                'Your wittiest subcaption',
                false,
                handleChangeCaption,
                setErrors,
                setMediaItem,
                mediaItem,
                1.5
              )}
            </Box>
          </Box>
        ))}

        {/* Save and Cancel Buttons */}
        {showSaveAndCancelButtons()
          && saveAndCancelButtonsJSX(
            loading.captions,
            (!(showSaveAndCancelButtons()) || loading.captions),
            handleCancelPressed,
            handleSavePressed,
            0,
            0,
            2,
            'warning',
            'primary'
          )
        }

        {/* Loading */}
        {loading.captions &&
          advisoryTypography(`Uploading Changes...`, 'center')
        }

        {/* Error Message */}
        {errors.captions &&
          standardErrorContainer(`There was an error uploading the changes. Check your Internet connection and try again.`)
        }

        {/* Save Successful */}
        {saveSuccessful.captions &&
          saveSuccessfulTypography()
        }
      </Box>
    </Box>
  )
}